

















import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { IState } from "@/store";

import Is403Component from "@/components/app/admin/403.vue";
import RequiresBrandComponent from "@/components/app/admin/tenancy/requiresBrand.vue";
import { IBrand } from "@/models/brands";

@Component({
  components: {
    "impersonation-ribbon": () =>
      import("@/components/app/global/client/impersonationRibbon.vue"),
    "content-header": () => import("./contentHeader.vue")
  },
  computed: {
    ...mapState({
      brandId: (state: IState) => state.auth.admin.brandId
    }),
    ...mapGetters({
      isAuthenticated: "auth/admin/isAuthenticated"
    })
  }
})
export default class AdminContent extends Vue {
  private brandId!: IBrand["id"];
  private isAuthenticated!: boolean;

  public get is403() {
    const permissions = this.$_.get(this.$route, "meta.auth", []);
    return (
      permissions.length && !this.$store.getters["user/can"](...permissions)
    );
  }

  public get brandOrgGuard() {
    return this.$_.head(
      this.$_.filter(
        this.$_.map(this.$route.matched, route => {
          return this.$_.pick(route.meta, ["requiresBrand", "requiresOrg"]);
        }),
        route => {
          return !this.$_.isEmpty(route);
        }
      )
    );
  }

  public get isBrandRouteInOrgContext() {
    return (
      this.$_.get(this.brandOrgGuard, "requiresBrand", false) &&
      this.$store.getters["brand/isMultibrand"]
    );
  }

  public get uniqueKey(): string {
    const parts: string[] = [];
    parts.push(`brand-${this.brandId}`);
    return parts.join("|");
  }

  public get component() {
    if (this.is403) {
      return Is403Component;
    }
    if (this.isBrandRouteInOrgContext) {
      return RequiresBrandComponent;
    }
    return null;
  }
}
